module.exports = __webpack_public_path__ + "static/media/travel22.f7cfb020.jpg";